import React from 'react';
import { Chip, Tooltip } from "@material-ui/core"
import moment from 'moment';
import { displayDateFormatShort } from '../../../constants';
const FilterOutput = ({ filter, filterMenu, onRemoveFilter, module }) => {
    const plotFilterValue = (key) => {
        switch (filterMenu[key].inputType) {
            case 'text':
                return <Chip size='small'
                    label={<span> <span style={{ fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium' }}>{filterMenu[key].title}</span>: {filter[key]} </span>} onDelete={() => onRemoveFilter(key)} />
            case 'number':
                return <Chip size='small'
                    label={<span> <span style={{ fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium' }}>{filterMenu[key].title}</span>: {filter[key]} </span>} onDelete={() => onRemoveFilter(key)} />
            case 'dropdown':
                const options = filterMenu[key]?.options;
                const valueKey = filterMenu[key]?.valueKey;
                const labelKey = filterMenu[key]?.labelKey;
                if (filterMenu[key].multiple) {
                    let value = '';
                    let trimData = 0;
                    let displayValue = '';
                    if (options && options?.length && valueKey && labelKey && filter[key]) {
                        let selectOptions = options.filter(item => filter[key]?.toString().split(',').includes(item[valueKey].toString()));
                        value = selectOptions?.map(item => item[labelKey])?.join(', ');
                        trimData = selectOptions?.length;
                        if (trimData > 8) {
                            displayValue = selectOptions.slice(0, 8).map(item => item[labelKey])?.join(', ') + ` ... +${trimData - 8} more`;
                        } else {
                            displayValue = value;
                        }
                    }
                    return value ? (
                        <Chip
                            size='small'
                            label={
                                <Tooltip title={trimData > 8 ? value : ''} placement='top' arrow>
                                    <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        <span style={{ fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium', flexShrink: 0 }}>{filterMenu[key]?.title}:</span>&nbsp;{displayValue}
                                    </span>
                                </Tooltip>
                            }
                            onDelete={() => onRemoveFilter(key)}
                        />
                    ) : null
                } else {
                    let value = options && options.length && valueKey && labelKey && filter[key] ? options.find(item => item[valueKey] === filter[key])[labelKey] : '';
                    return value ? <Chip size='small'
                        label={<span> <span style={{ fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium' }}>{filterMenu[key].title}</span>: {value} </span>} onDelete={() => onRemoveFilter(key)} /> : null
                }
            case 'date':
                return <Chip
                    size='small'
                    label={<span> <span style={{ fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium' }}>{filterMenu[key].title}</span>: {moment(filter[key]).format(filterMenu[key].format ? filterMenu[key].format : displayDateFormatShort)} </span>} onDelete={() => onRemoveFilter(key)} />
            default:
                return null
        }
    }
    const setOrderForFilter = () => {
        let newFilter = {};
        Object.keys(filterMenu).forEach(key => {
            if (filter[key]) {
                newFilter = {
                    ...newFilter,
                    [key]: filter[key]
                }
            }
        });
        return newFilter;
    }
    return (
        <div className='filter-result' style={{ overflow: 'hidden', width: '100%' }}>
            <ul className='list-inline' style={{ display: 'flex', flexWrap: 'wrap', margin: 0, padding: 0 }}>
                {Object.keys(setOrderForFilter(filter)).map((key, index) =>
                    filterMenu[key] ?
                        <li className='list-inline-item'>{plotFilterValue(key)}</li> : null
                )}
                {filter && Object.keys(filter).length && Object.keys(filter).length > 1 ?
                    <li className='list-inline-item'>
                        <Chip color='primary' size='small' label='Clear All' onDelete={() => onRemoveFilter('all')} />
                    </li> : null
                }
            </ul>
        </div>
    );
}
export default FilterOutput;